export default "__VITE_ASSET__Ds7TQS81__"